import { render, staticRenderFns } from "./notaDinas.vue?vue&type=template&id=99b9301a&"
import script from "./notaDinas.vue?vue&type=script&lang=js&"
export * from "./notaDinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports